import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

const INVENTORY_DISPLAY_SELECTOR = 'div[class*="ai-inventory-display-"]:not([class*="ai-inventory-display__"])';

/**
 * @param {Element} element
 * @returns {string | undefined}
 */
function getInventoryDisplayClass(element) {
  return Array.from(element.classList).find(
    (cls) => cls.startsWith('ai-inventory-display-') && !cls.includes('__')
  );
}

/**
 * @param {Event} event
 */
function updateInventoryDisplays(event) {
  if (!(event.target instanceof HTMLElement)) return;

  /** @type {import('@theme/events').VariantUpdateEvent} */
  const variantUpdateEvent = /** @type {import('@theme/events').VariantUpdateEvent} */ (event);

  const section = event.target.closest('.shopify-section, dialog');
  if (!section || !variantUpdateEvent.detail?.data?.html) return;

  section.querySelectorAll(INVENTORY_DISPLAY_SELECTOR).forEach((/** @type {Element} */ currentDisplay) => {
    const displayClass = getInventoryDisplayClass(currentDisplay);
    if (!displayClass) return;

    const newDisplay = variantUpdateEvent.detail.data.html.querySelector(`.${CSS.escape(displayClass)}`);
    if (!newDisplay) return;

    morph(currentDisplay, newDisplay, { childrenOnly: true });
  });
}

document.addEventListener(ThemeEvents.variantUpdate, updateInventoryDisplays);
